import { getFiGrowthBook } from '../lib/growthbook';

/**
 * The redesigned /checkout/stripe, behind 'ecom-cart-checkout-v2', the same flag that picks the
 * redesigned cart. Off, today's page renders.
 */
export default function useCheckoutV2(): boolean {
  return getFiGrowthBook().getFeatureValue<boolean>('ecom-cart-checkout-v2', false);
}
